import {DefaultResType, ErrorType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {
    SalesRevenueByCompanyCreateMapType,
    SalesRevenueByCompanyUpdateType,
    SalesSearchParamType
} from "../../pages/main/sales/list/interface";

const url = "api/home/revenue/";

export async function readTeamName(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_team_name");
    } catch (err: any) {
        return err?.response;
    }
}

export async function readHandlerName(data: { teamId: string }): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_handler_name", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function readRevenueTableSetting(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_revenue_table_setting");
    } catch (err: any) {
        return err?.response;
    }
}

export async function readYearlyRevenue(data: SalesSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_yearly_revenue", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function readRevenueByCompany(data: SalesSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_revenue_by_company", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function readAllRevenueByCompany(data: SalesSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_all_revenue_by_company", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function exportYearlyRevenueExcel(param: SalesSearchParamType): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.post(url + "export_yearly_revenue_excel", param, {
        responseType: "blob",
    });

    return response?.data;
}

export async function exportRevenueByCompanyExcel(param: SalesSearchParamType): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.post(url + "export_revenue_by_company_excel", param, {
        responseType: "blob",
    });

    return response?.data;
}

export async function updateRevenueTableSetting(data: {
    isHidden: string,
    revenueViewInfoId: number
}[]): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_revenue_table_setting", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateRevenue(data: SalesRevenueByCompanyUpdateType[]): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_revenue", data);
    } catch (err: any) {
        return err?.response;
    }
}

// category&vendor
export async function readNewProductGroup(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_new_product_group");
    } catch (err: any) {
        return err?.response;
    }
}

export async function readRevenueLastYear(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_revenue_last_year");
    } catch (err: any) {
        return err?.response;
    }
}

export async function uploadRevenueByCompanyExcel(data: FormData): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "upload_revenue_by_company_excel", data, {headers: {"Content-Type": "multipart/form-data"}});
    } catch (err: any) {
        return err?.response;
    }
}

export async function createRevenueByCompany(data: SalesRevenueByCompanyCreateMapType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "create_revenue_by_company", data);
    } catch (err: any) {
        return err?.response;
    }
}